ScoreTrekBattle.Tournament.Details = (function() {
    var _this, STATUS;

    function resetStatus() {
        STATUS = {
            active: false,
            action: null,
            $view: null,
            tournament: null,
            nextTournament: null,
            prevTournaments: [],
            teams: {},
            participants: {},
            participantSortKey: 'data-timestamp'
        };

        ScoreTrekBattle.Tournament.setCurrent(STATUS.tournament);
    }
    resetStatus();

    function onViewRender(tournamentId, action) {
        return new Promise(function(resolve) {
            STATUS.active = true;
            ScoreTrekBattle.View.loading('Tournament.Details.onViewRender', true);
            if (action) {
                STATUS.action = action;
            }
            loadTournament(tournamentId).then(() => {
            }).catch(error => {
                chmDialog.error(error).then(() => {
                    ScoreTrekBattle.View.goBack();
                });
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Details.onViewRender', false);
                renderTournament().then(view => {
                    STATUS.active = true;
                    STATUS.$view = view.$view;
                    applyTournamentData();
                    renderTournamentData(true, true);
                    resolve(STATUS.$view);
                });
            });
        });
    }

    function onViewLoad() {
        return new Promise(function(resolve) {
            var action;
            if (STATUS.tournament) {
                applyTournamentData();
                setTimeout(() => {
                    toggleReadMore(checkReadMore());
                }, 0);

                action = STATUS.action;
                STATUS.action = null;

                if (action === 'register') {
                    if (STATUS.tournament.playerStatus === 'none') {
                        confirmRegisterPlayer(ScoreTrekBattle.Session.getPlayerId());
                    } else {
                        chmDialog.info(__i18n('error/PARTICIPANT_ALREADY_REGISTERED'));
                    }
                }
            }
            resolve();
        });
    }

    function onViewUpdate(tournamentId, action) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.View.goto(`/tournament/details/${tournamentId}${action ? `/${action}` : ''}`, true, true);
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            resetStatus();
            resolve();
        });
    }

    function loadTournament(tournamentId, keepCache) {
        return new Promise(function(resolve, reject) {
            Api.request('/battle/tournament/details', {
                id: tournamentId
            }).then(result => {
                if (result && result.tournament && result.tournament.preset && result.tournament.preset.preset) {
                    STATUS.tournament = result.tournament;
                    STATUS.nextTournament = result.nextTournament || null;
                    STATUS.prevTournaments = result.prevTournaments || [];
                    STATUS.participants = {};
                    ScoreTrekBattle.Tournament.setCurrent(STATUS.tournament);
                    resolve(result);
                } else {
                    if (!keepCache) {
                        clearLoadedTournament();
                    }
                    reject(new Error('PRESET_DOES_NOT_EXIST'));
                }
            }).catch(error => {
                if (!keepCache) {
                    clearLoadedTournament();
                }
                reject(error);
            });
        });
    }

    function clearLoadedTournament() {
        STATUS.tournament = null;
        STATUS.nextTournament = null;
        STATUS.prevTournaments = [];
        STATUS.participants = {};
        ScoreTrekBattle.Tournament.setCurrent(null);
    }

    function renderTournament() {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render(STATUS.tournament ? 'tournament/details/overview' : 'tournament/details/empty', {
                tournament: STATUS.tournament,
                googleMapsUrl: ScoreTrekBattle.Tournament.getMapsUrl(STATUS.tournament)
            }, true).then(view => {
                let $detailsBox;

                if (STATUS.tournament) {
                    view.$view.find('[data-id="intro"]').html(__addHyperlinks(__escapeHTML(STATUS.tournament.intro), 'color-yellow')).toggle(!!STATUS.tournament.intro);
                    view.$view.find('[data-id="description"]').html(__addHyperlinks(__escapeHTML(STATUS.tournament.description), 'color-yellow'));
                    view.$view.find('[data-toggle-id]').each(function() {
                        let isOpen;

                        isOpen = ScoreTrekBattle.Tournament.Live.getOpenState(this.dataset.toggleId);

                        this.dataset.isOpen = isOpen ? 'yes' : 'no';
                        $(this).find('[data-ref="toggle"]').first()[isOpen ? 'show' : 'hide']();
                    });
                }

                view.$view.find('[data-ref-id="live"]').remove();

                resolve(view);
            });
        });
    }

    function refreshTournament(clear) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Details.refreshTournament', true);
            updateTournament(clear).then(resolve).catch(reject).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Details.refreshTournament', false);
            });
        });
    }

    function updateTournament(clear) {
        return new Promise(function(resolve, reject) {
            if (!STATUS.tournament) {
                reject();
                return;
            }
            loadTournament(STATUS.tournament.id, true).then(() => {
                applyTournamentData();
                if (clear) {
                    clearParticipants().then(() => {
                        renderTournamentData();
                        resolve();
                    });
                } else {
                    renderTournamentData();
                    resolve();
                }
            }).catch(reject);
        });
    }

    function clearParticipants(quick) {
        return new Promise(function(resolve) {
            var listPromises;
            listPromises = [];

            ['requests', 'participants', 'waitlist', 'blocklist'].forEach(listName => {
                var participantPromises;
                participantPromises = [];

                STATUS.$view.find(`[data-id="${listName}Items"] [data-participant-id]`).each(function() {
                    var $participant;
                    $participant = $(this);
                    participantPromises.push(new Promise(function(resolveParticipant) {
                        $participant.slideUp(quick ? 0 : 400);
                        setTimeout(() => {
                            $participant.remove();
                            resolveParticipant();
                        }, quick ? 0 : 400);
                    }));
                });

                listPromises.push(Promise.all(participantPromises));
            });

            Promise.all(listPromises).then(() => {
                checkListItems(quick);
                sortParticipants();
            }).finally(resolve);
        });
    }

    function renderTournamentData(quick, keepOrder) {
        STATUS.participants = {};

        ['requests', 'participants', 'waitlist', 'blocklist'].forEach(listName => {
            var participants, availableParticipants, existingParticipants, addParticipants, removeParticipants;
            if (STATUS.tournament[listName]) {
                STATUS.$view.find(`[data-id="${listName}Count"]`).text(STATUS.tournament[listName].length);

                participants = {};
                STATUS.tournament[listName].forEach(participant => {
                    participants[participant.id] = participant;
                    STATUS.participants[participant.id] = participant;
                });
                availableParticipants = Object.keys(participants);

                existingParticipants = [];
                STATUS.$view.find(`[data-id="${listName}Items"] [data-participant-id]`).each(function() {
                    existingParticipants.push(this.dataset.participantId);
                });

                addParticipants = availableParticipants.filter(participantId => (existingParticipants.indexOf(participantId) < 0));
                removeParticipants = existingParticipants.filter(participantId => (availableParticipants.indexOf(participantId) < 0));
                updateParticipants = existingParticipants.filter(participantId => (removeParticipants.indexOf(participantId) < 0));

                removeParticipants.forEach(participantId => {
                    removeParticipant(listName, participantId, quick);
                });

                updateParticipants.forEach(participantId => {
                    updateParticipant(listName, participants[participantId]);
                });

                addParticipants.forEach(participantId => {
                    addParticipant(listName, participants[participantId], quick, keepOrder);
                });

                updateStackOrder(listName);
            }
        });

        ['blocklist'].forEach(listName => {
            if (STATUS.tournament[listName]) {
                STATUS.$view.find(`[data-id="${listName}"]`)[(STATUS.tournament[listName].length === 0) ? 'slideUp' : 'slideDown']();
            }
        });

        ScoreTrekBattle.Tournament.renderInfos(STATUS.tournament, STATUS.$view);
        ScoreTrekBattle.Tournament.renderModeInfo(STATUS.tournament, STATUS.$view);
        ScoreTrekBattle.Tournament.renderPrevTournaments(STATUS.prevTournaments, STATUS.$view.find('[data-id="prevTournaments"]'));
        ScoreTrekBattle.Tournament.renderNextTournament(STATUS.nextTournament, STATUS.$view.find('[data-id="nextTournament"]'), STATUS.tournament.qualificantsCount);

        checkListItems(quick);
        sortParticipants();
    }

    function applyTournamentData() {
        if (!STATUS.$view || !STATUS.tournament) {
            return;
        }
        ScoreTrekBattle.View.updateMenu(ScoreTrekBattle.Tournament.getMenuLink(STATUS.tournament.statusInfo));
        STATUS.$view.attr({
            'data-tournament-status': STATUS.tournament.statusInfo,
            'data-participant-status': ScoreTrekBattle.Session.hasPlayer() ? STATUS.tournament.playerStatus : 'unauthorized',
            'data-has-waitlist': STATUS.tournament.hasWaitlist ? 'yes' : 'no',
            'data-is-invitation': STATUS.tournament.isInvitation ? 'yes' : 'no',
            'data-has-teams': (STATUS.tournament.preset.playerType !== 'single') ? 'yes' : 'no',
            'data-has-payment': STATUS.tournament.entryFee ? 'yes' : 'no'
        });
        STATUS.$view.find('[data-id="registrationNotice"]').css('display', (STATUS.tournament.hasRegistration && !STATUS.tournament.isRegistrationUnlocked) ? '' : 'none');

        if (!STATUS.tournament.series) {
            STATUS.$view.find('[data-ref-id="tournamentSeries"]').remove();
        }

        if (!STATUS.tournament.nextTournamentId) {
            STATUS.$view.find('[data-ref-id="prevTournament"]').remove();
        }

        if (!STATUS.tournament.isNextTournament) {
            STATUS.$view.find('[data-ref-id="nextTournament"]').remove();
        }

        if (!STATUS.tournament.pointsMapId) {
            STATUS.$view.find('[data-ref-id="tournamentPointsMap"]').remove();
        }

        mapTeams();
    }

    function mapTeams() {
        STATUS.teams = {};
        if (!STATUS.tournament || !STATUS.tournament.teams || (STATUS.tournament.teams.length === 0)) {
            return;
        }
        STATUS.tournament.teams.forEach(team => {
            STATUS.teams[team.id] = team;
        });
    }

    function updateStackOrder(listName) {
        let $items, zIndex;
        $items = STATUS.$view.find(`[data-id="${listName}Items"]`).children();
        zIndex = $items.length;
        $items.each(function() {
            this.style.zIndex = zIndex;
            zIndex--;
        });
    }

    function renderParticipant(participant) {
        var isCustom, isDeleted, isVerified, isProPlayer;

        if (participant && participant.player) {
            isCustom = !!participant.player.custom;
            isDeleted = !!participant.player.deleted;
            isVerified = !!participant.player.verified;
            isProPlayer = !!participant.player.pro_account;
        }

        if (participant && !participant.player) {
            participant.player = {};
        }

        if (participant) {
            STATUS.participants[participant.id] = participant;
        }

        return participant
            ? $([
                `<div class="p-medium player-item${isProPlayer ? ' isProPlayer' : ''}"${(isDeleted || isCustom) ? ` title="${__i18n(isDeleted ? 'player/deleted' : 'player/custom')}"` : ''} data-player-id="${participant.playerId}" data-participant-id="${participant.id}" data-participant-status="${participant.status}" data-team-id="${participant.teamId}" data-verified="${isVerified ? 'yes' : 'no'}" data-paid="${participant.paid ? 'yes' : 'no'}" data-timestamp="${participant.dateTimeRequestTimestamp}" data-trigger-action="participant.info">`,
                    `<div class="player">`,
                        `<span data-id="payStatus" class="player-pay-status row-center show-battle-manager" data-show-for-club="${STATUS.tournament.clubId}" data-hide-tournament-status="done,sealed">`,
                            `<span class="player-paid payment-badge-decent badge bg-color-dark-green color-white mr-small" data-info-popup="player/info/paid"><i class="fa-solid fa-euro-sign"></i></span>`,
                            `<span class="player-paid payment-badge badge bg-color-dark-green color-white mr-small" data-info-popup="player/info/paid"><i class="fa-solid fa-euro-sign"></i></span>`,
                            `<span class="player-unpaid payment-badge-decent badge bg-color-gray color-light-gray mr-small" data-info-popup="player/info/unpaid"><i class="fa-solid fa-euro-sign"></i></span>`,
                            `<span class="player-unpaid payment-badge badge bg-color-dark-red color-light-gray mr-small" data-info-popup="player/info/unpaid"><i class="fa-solid fa-euro-sign"></i></span>`,
                        `</span>`,
                        `${getPrevTournamentPosition(participant)}`,
                        `<span class="player-avatar" style="background-image:url('${participant.player.thumbnail}');" data-trigger-action="participant.info"></span>`,
                        `<span class="player-name-wrapper" data-trigger-action="participant.info">`,
                            `<span class="player-name-team row-center" data-id="teamName">${getTeamName(participant.teamId)}</span>`,
                            `<span class="player-name row-center${isDeleted ? ' text-middle-gray text-italic' : ''}" data-id="playerName">${participant.player.name ? __escapeHTML(participant.player.name) : __escapeHTML(participant.fullName)}</span>`,
                        `</span>`,
                        `${(participant.status === 'requested') ? '<span class="row-center"><span class="badge bg-color-white-10 color-light-pink ml-small" data-info-popup="player/info/requested;player/info/tapForMore"><i class="fa-solid fa-user-tag"></i></span></span>' : ''}`,
                        `${isCustom ? `<span class="row-center"><span class="badge bg-color-white color-pink ml-small" data-info-popup="player/info/custom;player/info/tapForMore"><i class="fa-solid fa-user-slash"></i></span></span>` : ''}`,
                        `${!isVerified ? `<span class="row-center"><span class="badge bg-color-pink color-white ml-small" data-info-popup="player/info/notVerified;player/info/tapForMore"><i class="fa-solid fa-triangle-exclamation"></i></span></span>` : ''}`,
                    `</div>`,
                    `<div class="player-controls show-battle-manager ml-small" data-show-for-club="${STATUS.tournament.clubId}">`,
                        `<div class="button button-invisible button-small overflow-visible">`,
                            `<div class="context-menu isDown">`,
                                `<div class="context-menu-toggle" title="${__i18n('button/more')}">`,
                                    `<i class="fa-solid fa-ellipsis"></i>`,
                                `</div>`,
                                `<div class="context-menu-items">`,
                                    `<div class="context-menu-items-item" data-trigger-action="participant.pay" data-show-tournament-status="scheduled,running">`,
                                        `<i class="color-green"><i class="fa-solid fa-euro-sign"></i></i>`,
                                        `<span>${__i18n('action/pay')}</span>`,
                                    `</div>`,
                                    `<div class="context-menu-items-item" data-trigger-action="participant.unpay" data-show-tournament-status="scheduled,running">`,
                                        `<i class="color-red"><i class="fa-solid fa-euro-sign"></i></i>`,
                                        `<span>${__i18n('action/unpay')}</span>`,
                                    `</div>`,
                                    `<div class="context-menu-items-item show-admin-mode" data-trigger-action="participant.confirmRequest" data-show-tournament-status="scheduled" data-show-access-level="sys_admin">`,
                                        `<i class="color-light-pink"><i class="fa-solid fa-check"></i></i>`,
                                        `<span>${__i18n('button/confirmRequest')}</span>`,
                                    `</div>`,
                                    `<div class="context-menu-items-item" data-trigger-action="participant.reset" data-show-tournament-status="scheduled">`,
                                        `<i class="color-blue"><i class="fa-solid fa-rotate-left"></i></i>`,
                                        `<span>${__i18n('action/reset')}</span>`,
                                    `</div>`,
                                    `<div class="context-menu-items-item" data-trigger-action="participant.accept" data-show-tournament-status="scheduled">`,
                                        `<i class="color-green"><i class="fa-solid fa-check"></i></i>`,
                                        `<span>${__i18n('action/accept')}</span>`,
                                    `</div>`,
                                    `<div class="context-menu-items-item" data-trigger-action="participant.wait" data-show-tournament-status="scheduled">`,
                                        `<i class="color-yellow"><i class="fa-solid fa-question"></i></i>`,
                                        `<span>${__i18n('action/wait')}</span>`,
                                    `</div>`,
                                    `<div class="context-menu-items-item" data-trigger-action="participant.block" data-show-tournament-status="scheduled">`,
                                        `<i class="color-red"><i class="fa-solid fa-minus"></i></i>`,
                                        `<span>${__i18n('action/block')}</span>`,
                                    `</div>`,
                                    `<div class="context-menu-items-item" data-trigger-action="participant.deny" data-show-tournament-status="scheduled,running">`,
                                        `<i class="color-white"><i class="fa-regular fa-trash-can"></i></i>`,
                                        `<span>${__i18n('action/deny')}</span>`,
                                    `</div>`,
                                    `<div class="context-menu-items-item" data-trigger-action="participant.contact">`,
                                        `<i class="color-light-pink"><i class="fa-regular fa-envelope"></i></i>`,
                                        `<span>${__i18n('action/contact')}</span>`,
                                    `</div>`,
                                    `<div class="context-menu-items-item" data-trigger-action="participant.verifyPlayer">`,
                                        `<i class="color-light-pink"><i class="fa-solid fa-check-double"></i></i>`,
                                        `<span>${__i18n('action/verifyPlayer')}</span>`,
                                    `</div>`,
                                    `<div class="context-menu-items-item" data-trigger-action="participant.renamePlayer" data-show-tournament-status="scheduled,starting,running,done">`,
                                        `<i class="color-white"><i class="fa-solid fa-user-pen"></i></i>`,
                                        `<span>${__i18n('action/renamePlayer')}</span>`,
                                    `</div>`,
                                    `<div class="context-menu-items-item" data-trigger-action="participant.linkPlayer" data-show-access-level="sys_admin">`,
                                        `<i class="color-light-pink"><i class="fa-solid fa-link"></i></i>`,
                                        `<span>${__i18n('action/linkPlayer')}</span>`,
                                    `</div>`,
                                    `<div class="context-menu-items-item" data-trigger-action="participant.unlinkPlayer" data-show-access-level="sys_admin">`,
                                        `<i class="color-light-pink"><i class="fa-solid fa-link-slash"></i></i>`,
                                        `<span>${__i18n('action/unlinkPlayer')}</span>`,
                                    `</div>`,
                                    `<div class="context-menu-items-item" data-trigger-action="participant.info">`,
                                        `<i class="color-white"><i class="fa-regular fa-user"></i></i>`,
                                        `<span>${__i18n('action/info')}</span>`,
                                    `</div>`,
                                `</div>`,
                            `</div>`,
                        `</div>`,

                        `<span class="button button-transparent button-input button-tiny ml-small color-white" data-trigger-action="participant.pay" data-show-tournament-status="scheduled,running" title="${__i18n('action/pay')}"><i class="fa-solid fa-euro-sign"></i></span>`,
                        `<span class="button button-transparent button-input button-tiny ml-small color-white" data-trigger-action="participant.unpay" data-show-tournament-status="scheduled,running" title="${__i18n('action/unpay')}"><i class="fa-solid fa-euro-sign"></i></span>`,
                        `<span class="button button-transparent button-input button-tiny ml-small color-green" data-trigger-action="participant.accept" data-show-tournament-status="scheduled" title="${__i18n('action/accept')}"><i class="fa-solid fa-check"></i></span>`,
                        `<span class="button button-transparent button-input button-tiny ml-small color-white" data-trigger-action="participant.info" data-show-tournament-status="scheduled" title="${__i18n('action/info')}"><i class="fa-regular fa-user"></i></span>`,
                        `<span class="button button-transparent button-input button-tiny ml-small color-blue" data-trigger-action="participant.reset" data-show-tournament-status="scheduled" title="${__i18n('action/reset')}"><i class="fa-solid fa-rotate-left"></i></span>`,

                    `</div>`,
                `</div>`
            ].join(''))
            : $([
                `<div class="p-medium player-item color-white-40" data-player-id="" data-participant-id="" data-timestamp="0">`,
                    `<div class="player">`,
                        `<span class="player-avatar"><i class="fa-solid fa-inbox"></i></span>`,
                        `<span class="player-name">${__i18n('game/noParticipants')}</span>`,
                    `</div>`,
                `</div>`
            ].join(''));
    }

    function getPrevTournamentPosition(participant) {
        let hasGroup;

        if (!participant.prevTournamentId || !participant.prevTournamentPosition) {
            return '';
        }

        hasGroup = (participant.prevTournamentGroupNumber > 0);

        return [
            `<span class="bg-color-white-10 rounded-semi p-small pb-tiny ml-tiny mr-small" title="${__i18n('player/info/qualified')}" data-trigger-action="participant.info">`,
                `<span class="row-center">`,
                    `<span class="color-white mr-tiny${hasGroup ? ' text-small' : ''}">`,
                        `<i class="fa-solid fa-diagram-project"></i>`,
                        hasGroup ? `<span class="text-smaller ml-tiny">${__i18n('game/groupShort', {group: participant.prevTournamentGroupNumber})}:</span>` : '',
                    `</span>`,
                    `<span class="color-blue text-bold">`,
                        `${participant.prevTournamentPosition}.`,
                    `</span>`,
                `</span>`,
            `</span>`
        ].join('');
    }

    function getTeamName(teamId) {
        if (!STATUS.teams || !STATUS.teams[teamId]) {
            return '';
        }

        return STATUS.teams[teamId].name;
    }

    function addParticipant(listName, participant, quick, keepOrder) {
        var $listItems, $participant, $nextParticipant, participantTimestamp;

        $participant = renderParticipant(participant);
        $participant.hide();

        $listItems = STATUS.$view.find(`[data-id="${listName}Items"]`);

        if (!keepOrder) {
            participantTimestamp = parseInt($participant.attr('data-timestamp'), 10);
            $listItems.children().each(function() {
                var itemTimestamp;
                itemTimestamp = parseInt(this.dataset.timestamp, 10);
                if (itemTimestamp > participantTimestamp) {
                    $nextParticipant = $(this);
                    return false;
                }
            });
        }

        if ($nextParticipant) {
            $nextParticipant.before($participant);
        } else {
            $listItems.append($participant);
        }

        checkListItems(quick);
        sortParticipants();
        $participant.slideDown(quick ? 0 : 400);
    }

    function updateParticipant(listName, participant) {
        var $listItems, $participant, $updatedParticipant;

        $updatedParticipant = renderParticipant(participant);

        $listItems = STATUS.$view.find(`[data-id="${listName}Items"]`);

        $participant = $listItems.find(`[data-participant-id="${participant.id}"]`);

        if ($participant.length === 0) {
            return;
        }

        $participant.replaceWith($updatedParticipant);

        sortParticipants();
    }

    function removeParticipant(listName, participantId, quick) {
        STATUS.$view.find(`[data-id="lists"] [data-id="${listName}"] [data-participant-id="${participantId}"]`).slideUp(quick ? 0 : 400, function() {
            $(this).remove();
            checkListItems(quick);
            sortParticipants();
        });
    }

    function renderPlayer(player, type) {
        let clubHtml, club, clubLogo, clubAddress;

        clubHtml = '';
        if ((type === 'searchResult') && player.club) {
            club = player.club;
            clubLogo = club.thumbnail || club.logo || '';
            clubAddress = `${club.zip || ''} ${club.city || ''}`.trim();
            clubHtml = [
                `<div class="player-club">`,
                    `<span class="player-club-logo"${clubLogo ? ` style="background-image:url('${clubLogo}');"` : ''}></span>`,
                    `<span class="player-club-text">`,
                        `<span class="player-club-name">${__escapeHTML(club.official_name || '')}</span>`,
                        clubAddress ? `<span class="player-club-address">${__escapeHTML(clubAddress)}</span>` : '',
                    `</span>`,
                `</div>`
            ].join('');
        }

        return $([`<div class="p-medium player-item${player.pro_account ? ' isProPlayer' : ''}"${type ? ` data-item-type="${type}"` : ''} data-player-id="${player.id}" data-verified="${player.verified ? 'yes' : 'no'}">`,
            `<div class="player">`,
                `<span class="player-avatar" style="background-image:url('${player.thumbnail}');"></span>`,
                `<span class="player-name-wrapper">`,
                    `<span class="player-name row-center" data-id="playerName">`,
                        `${__escapeHTML(player.name)}`,
                    `</span>`,
                    clubHtml,
                `</span>`,
                `${!player.verified ? `<span class="row-center"><span class="badge bg-color-pink color-white ml-small" data-info-popup="player/info/notVerified"><i class="fa-solid fa-triangle-exclamation"></i></span></span>` : ''}`,
            `</div>`,
        `</div>`].join(''));
    }

    function playerExists(playerId) {
        if (!STATUS.$view) {
            return false;
        }

        return (STATUS.$view.find(`[data-id="lists"] [data-player-id="${playerId}"]`).length > 0);
    }

    function addParticipantWithCode(autoFocus) {
        var dialog, codeUrl, $qrCodeScan, $manualAdd, $searchInput, $searchResults, $searchResultsItems, isSearchActive, searches;

        if (!STATUS.tournament) {
            return;
        }

        function toggleSearch(isActive) {
            let hasValue;

            hasValue = $searchInput.val().length > 0;

            if (!isActive) {
                $searchInput.val('');
                $searchResultsItems.empty();
                $searchResults.removeClass('loading');
                cancelSearch();

                if (!hasValue && !isSearchActive) {
                    dialog.close();
                }
            }

            if (isActive === isSearchActive) {
                return;
            }

            isSearchActive = isActive;

            // dialog.hideButtons(isActive, true);
            $searchResults.stop()[isActive ? 'slideDown' : 'slideUp'](0);
            $qrCodeScan.add($manualAdd).stop()[isActive ? 'slideUp' : 'slideDown'](0)
        }

        function cancelSearch() {
            searches.forEach(search => {
                search.cancel();
            });
        }

        function isSearching() {
            let isRunning;

            isRunning = false;
            searches.forEach(search => {
                isRunning = isRunning || search.isRunning();
            });

            return isRunning;
        }

        function startSearch() {
            let text, search;

            if (isSearching()) {
                setTimeout(startSearch, 500);
                return;
            }

            text = String($searchInput.val()).trim();

            if (text.length < 2) {
                return;
            }

            $searchResults.addClass('loading');

            search = chmSearch('/battle/search/player');

            search.search(text).then(result => {
                $searchResultsItems.empty();
                result.players.forEach(player => {
                    let $player, isParticipant;

                    $player = renderPlayer(player, 'searchResult');

                    isParticipant = playerExists(player.id);

                    $player.on('click', () => {
                        showPlayerInfo(player, !isParticipant).then(playerId => {
                            if (!playerId) {
                                return;
                            }
                            requestPlayer(playerId).then(() => {
                                $searchResultsItems.find('[data-player-id]').each(function() {
                                    this.classList.toggle('isDisabled', playerExists(this.dataset.playerId));
                                });
                            }).catch(error => {
                                if (error && error.message) {
                                    chmDialog.error(error);
                                }
                            });
                        });
                    });

                    if (isParticipant) {
                        $player.addClass('isDisabled');
                    }

                    $searchResultsItems.append($player);
                })
                $searchResults.removeClass('loading');
            }).catch(isCancelled => {
                console.warn(isCancelled);
                if (!isCancelled) {
                    $searchResults.removeClass('loading');
                }
            });

            searches.push(search);
        }

        isSearchActive = false;
        searches = [];

        codeUrl = `https://${location.host}/tournament/details/${STATUS.tournament.id}/register`

        $qrCodeScan = $('<div>').append(
            $('<div>').addClass('mb-medium').html(__i18n('dialog/participant/add/intro')),
            $('<div>').addClass('qrCode').append(chmQrCode(codeUrl)),
            $('<div>').addClass('mt-small text-decent text-small').html(__i18n('dialog/participant/add/notice'))
        );

        $manualAdd = $('<div>').addClass('pt-small').append(
            $('<a>').addClass('text-link').html(__i18n('button/addManual')).attr({
                href: 'javascript:'
            }).on('click', function() {
                dialog.close().then(() => {
                    ScoreTrekBattle.Event.trigger('action.participant.add.manual');
                });
            })
        );

        $searchInput = $('<input>').attr({
            'type': 'text',
            'placeholder': __i18n('action/searchPlayer')
        }).addClass('player-search-input-text').on('focus', function() {
            toggleSearch(true);
        }).on('blur', function() {
            if ((this.value === '') && isSearchActive) {
                toggleSearch(false);
            }
        }).on('input', function() {
            toggleSearch(this.value !== '');
            startSearch();
        }).on('keydown', function(event) {
            if ([13, 27].indexOf(event.which) >= 0) {
                event.stopPropagation();
            }

            if (event.which === 27) {
                toggleSearch(false);
            }
        });

        $searchResults = $('<div>').addClass('player-search-results loader');
        $searchResultsItems = $('<div>').addClass('player-search-results-items');

        dialog = chmDialog({
            title: __i18n('dialog/participant/add/title'),
            paddingTop: false,
            isPersistant: true,
            typeToFocus: $searchInput,
            content: $('<div>').append(
                $('<div>').addClass('row row-center row-between pb-medium').append(
                    $('<div>').addClass('player-search-input').append(
                        $searchInput,
                        $('<span>').addClass('player-search-input-icon').html('<i class="fa-solid fa-magnifying-glass"></i>')
                    ),
                    $('<span>').addClass('button button-transparent button-small').html('<i class="fa-solid fa-xmark"></i>').on('click', function() {
                        if (!isSearchActive) {
                            dialog.close();
                        }
                        toggleSearch(false);
                    })
                ),
                $searchResults.hide().append($searchResultsItems),
                $qrCodeScan,
                $manualAdd
            ),
            onShow: function() {
                if (autoFocus) {
                    $searchInput.focus();
                }
            },
            afterClose: function() {
                updateTournament();
            }
        });
    }

    function addParticipantManual() {
        chmDialog.confirm(__i18n('dialog/confirm/createParticipant/text', {tournamentName: STATUS.tournament.title}, true), {
            title: __i18n('dialog/confirm/createParticipant/title'),
            buttonYes: __i18n('button/cancel'),
            buttonNo: __i18n('button/add')
        }).then(() => {
            //ignore
        }).catch(() => {
            createParticipant();
        });
    }

    function checkListItems(quick) {
        if (!STATUS.$view) {
            return;
        }

        STATUS.$view.find('[data-id="lists"] .tournament-players-list').each(function() {
            var $list, $item;
            $list = $(this);
            if ($list.children().length === 0) {
                $item = renderParticipant(null);
                $item.hide();
                $list.append($item);
                $item.slideDown(quick ? 0 : 400);
            }
            if ($list.children().length > 1) {
                $list.find('[data-participant-id=""]').slideUp(quick ? 0 : 400, function() {
                    $(this).remove();
                });
            }
        });
    }

    function updateSortMenu() {
        if (!STATUS.$view) {
            return;
        }

        STATUS.$view.find('[data-trigger-action^="participants.sort"]').removeClass('isSelected').filter(`[data-trigger-action="participants.sort:${STATUS.participantSortKey}"]`).addClass('isSelected');
    }

    function setParticipantsSortKey(sortKey) {
        if (!STATUS.tournament) {
            return;
        }

        STATUS.participantSortKey = sortKey;

        sortParticipants();
    }

    function sortParticipants() {
        let $participants, participantItems;

        if (!STATUS.$view) {
            return;
        }

        updateSortMenu();

        $participants = STATUS.$view.find('[data-id="participantsItems"]');
        participantItems = $participants.children().get();
        participantItems.sort(compareParticipants);
        $participants.append(participantItems);

        updateStackOrder('participants');
    }

    function compareParticipants(participantItemA, participantItemB) {
        let valueA, valueB;

        valueA = getParticipantSortValue(participantItemA);
        valueB = getParticipantSortValue(participantItemB);

        return (valueA < valueB) ? -1 : (valueA > valueB) ? 1 : 0;
    }

    function getParticipantSortValue(participantItem) {
        try {
            if (STATUS.participantSortKey.substr(0, 5) === 'data-') {
                return String(participantItem.getAttribute(STATUS.participantSortKey)).trim();
            } else {
                return String(participantItem.querySelector(`[data-id="${STATUS.participantSortKey}"]`).textContent).trim();
            }
        } catch (error) {
            return '';
        }
    }

    function createParticipant() {
        if (!STATUS.tournament) {
            return;
        }

        editParticipantName('').then(participantName => {
            ScoreTrekBattle.View.loading('Tournament.Details.createParticipant', true);
            Api.request('/battle/participant/create', {
                tournamentId: STATUS.tournament.id,
                name: participantName
            }).then(result => {
                updateTournament();
            }).catch(error => {
                if (error && error.message) {
                    chmDialog.error(error);
                }
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Details.createParticipant', false);
            });
        }).catch(ignore => {});
    }

    function editParticipantName(currentParticipantName, isRename) {
        return new Promise(function(resolve, reject) {
            chmDialog.prompt({
                title: __i18n(`dialog/participant/${isRename ? 'rename' : 'name'}/title`),
                prompt: __i18n(`dialog/participant/${isRename ? 'rename' : 'name'}/prompt`, {playerName: currentParticipantName}, true),
                value: currentParticipantName
            }).then(participantName => {
                if (!participantName) {
                    reject();
                    return;
                }
                resolve(participantName);
            }).catch(reject);
        });
    }

    function confirmRegisterPlayer(playerId) {
        let isContactDataVisible;

        isContactDataVisible = true;

        if (ScoreTrekBattle.Session.hasPlayer()) {
            ScoreTrekBattle.Template.render('tournament/details/registerCheckbox').then(checkboxView => {
                chmDialog.confirm(__i18n('dialog/confirm/register/text', {
                    tournamentName: STATUS.tournament.title,
                    tournamentDate: STATUS.tournament.dateTimeTournament,
                    clubName: `${STATUS.tournament.club.name}, ${STATUS.tournament.club.city}`
                }, true), {
                    title: __i18n('dialog/confirm/register/title'),
                    buttonYes: __i18n('button/participate'),
                    buttonNo: __i18n('button/cancel')
                }, {
                    onRender: function() {
                        checkboxView.controls.isContactDataVisible.set(true).on('change', function() {
                            isContactDataVisible = this.get();
                        });
                        this.find(':first-child').closest('.dialog-content').append(checkboxView.$view);
                    }
                }).then(() => {
                    registerPlayer(playerId, isContactDataVisible);
                }).catch(() => {});
            });
        } else {
            ScoreTrekBattle.Session.showLoginNotice();
        }
    }

    function registerPlayer(playerId, isContactDataVisible) {
        if (!STATUS.tournament) {
            return;
        }

        ScoreTrekBattle.View.loading('Tournament.Details.registerPlayer', true);
        Api.request('/battle/tournament/register', {
            tournamentId: STATUS.tournament.id,
            playerId: playerId,
            isContactDataVisible: !!isContactDataVisible
        }).then(result => {
            updateTournament(true).then(() => {
                if (result && result.participant && (result.participant.playerId === ScoreTrekBattle.Session.getPlayerId()) && ['waiting', 'pending'].indexOf(result.participant.status) >= 0) {
                    chmDialog.info(__i18n(`tournament/registration/${result.participant.status}/info`), null, __i18n('button/ok'));
                }
            });
        }).catch(error => {
            if (error && error.message) {
                if ((error.message === 'REGISTRATION_LOCKED') && (STATUS.tournament.hasRegistration)) {
                    showTournamentRegistrationLock(__i18n(`error/${error.message}`));
                } else {
                    chmDialog.error(error);
                }
            }
        }).finally(() => {
            ScoreTrekBattle.View.loading('Tournament.Details.registerPlayer', false);
        });
    }

    function withdrawPlayer() {
        if (!STATUS.tournament) {
            return;
        }

        ScoreTrekBattle.View.loading('Tournament.Details.withdrawPlayer', true);
        Api.request('/battle/tournament/withdraw', {
            tournamentId: STATUS.tournament.id,
            playerId: ScoreTrekBattle.Session.getPlayerId()
        }).then(result => {
            updateTournament();
        }).catch(error => {
            if (error && error.message) {
                if ((error.message === 'WITHDRAW_LOCKED') && (STATUS.tournament.hasWithdrawLimit)) {
                    showTournamentWithdrawLock(__i18n(`error/${error.message}`));
                } else {
                    chmDialog.error(error);
                }
            }
        }).finally(() => {
            ScoreTrekBattle.View.loading('Tournament.Details.withdrawPlayer', false);
        });
    }

    function requestPlayer(playerId) {
        return new Promise((resolve, reject) => {
            if (!STATUS.tournament) {
                reject();
                return;
            }

            ScoreTrekBattle.View.loading('Tournament.Details.requestPlayer', true);
            Api.request('/battle/participant/request', {
                tournamentId: STATUS.tournament.id,
                playerId: playerId
            }).then(result => {
                ScoreTrekBattle.View.loading('Tournament.Details.requestPlayer.updateTournament', true);
                updateTournament(true).catch(ignore => {}).finally(() => {
                    ScoreTrekBattle.View.loading('Tournament.Details.requestPlayer.updateTournament', false);
                    resolve();
                });
            }).catch(error => {
                reject(error);
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Details.requestPlayer', false);
            });
        });
    }

    function loadParticipant(participantId) {
        return new Promise(resolve => {
            if (STATUS.participants.hasOwnProperty(participantId)) {
                resolve(STATUS.participants[participantId]);
                return;
            }

            ScoreTrekBattle.View.loading('Tournament.Details.loadParticipant', true);
            Api.request('/battle/participant/data', {
                participantId: participantId
            }).then(result => {
                resolve(result.participant);
            }).catch(error => {
                if (error) {
                    chmDialog.error(error);
                }
                resolve(null);
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Details.loadParticipant', false);
            });
        });
    }

    function showParticipantInfo(participantId) {
        loadParticipant(participantId).then(participant => {
            if (!participant) {
                return;
            }
            ScoreTrekBattle.Information.showParticipantInfo(participant, false);
        });
    }

    function showParticipantContact(participantId) {
        ScoreTrekBattle.View.loading('Tournament.Details.showParticipantContact', true);
        Api.request('/battle/participant/contactData', {
            participantId: participantId
        }).then(result => {
            ScoreTrekBattle.Information.showParticipantContact(result.participant, result.contactData);
        }).catch(error => {
            if (error) {
                chmDialog.error(error);
            }
        }).finally(() => {
            ScoreTrekBattle.View.loading('Tournament.Details.showParticipantContact', false);
        });
    }

    function showPlayerInfo(player, allowAdd) {
        return new Promise(resolve => {
            ScoreTrekBattle.Information.showParticipantInfo({
                id: null,
                playerId: player.id,
                player: player
            }, allowAdd ? [
                {
                    label: __i18n('button/requestParticipation'),
                    primary: true,
                    action: function() {
                        resolve(player.id);
                    }
                }
            ] : null);
        });
    }

    function verifyPlayer(participantId) {
        var participant;

        if (!STATUS.tournament || !STATUS.participants.hasOwnProperty(participantId)) {
            return;
        }

        participant = STATUS.participants[participantId];

        if (!participant.player || !participant.player.id || participant.player.verified) {
            return;
        }

        chmDialog.confirm(__i18n('dialog/confirm/verifyPlayer/text', {playerName: participant.player.name}, true), {
            title: __i18n('dialog/confirm/verifyPlayer/title'),
            buttonYes: __i18n('button/verify'), 
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            ScoreTrekBattle.View.loading('Tournament.Details.verifyPlayer', true);
            Api.request('/battle/participant/verifyPlayer', {
                tournamentId: STATUS.tournament.id,
                participantId: participantId,
                playerId: participant.player.id
            }).then(result => {
                if (result && result.done) {
                    updateTournament(true);
                }
            }).catch(error => {
                if (error && error.message) {
                    chmDialog.error(error);
                }
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Details.verifyPlayer', false);
            });
        });
    }

    function renamePlayer(participantId, participantName) {
        if (!STATUS.tournament) {
            return;
        }

        editParticipantName(participantName, true).then(newParticipantName => {
            ScoreTrekBattle.View.loading('Tournament.Details.renamePlayer', true);
            Api.request('/battle/participant/rename', {
                tournamentId: STATUS.tournament.id,
                participantId: participantId,
                name: newParticipantName
            }).then(result => {
                if (result && result.participant) {
                    STATUS.$view.find(`[data-participant-id="${participantId}"] [data-id="playerName"]`).text(result.participant.fullName);
                }
            }).catch(error => {
                if (error && error.message) {
                    chmDialog.error(error);
                }
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Details.renamePlayer', false);
            });
        }).catch(ignore => {});
    }

    function linkPlayer(participantId) {
        let dialog;

        if (!STATUS.tournament) {
            return;
        }

        dialog = ScoreTrekBattle.PlayerSearch.open({
            title: __i18n('action/linkPlayer'),
            placeholder: __i18n('action/searchPlayer'),
            onSelect: function(player) {
                console.log(player);
                if (!player || !player.id) {
                    return;
                }

                ScoreTrekBattle.View.loading('Tournament.Details.linkPlayer', true);
                Api.request('/battle/participant/linkPlayer', {
                    tournamentId: STATUS.tournament.id,
                    participantId: participantId,
                    playerId: player.id
                }).then(result => {
                    if (result && result.done) {
                        updateTournament(true);
                    }
                }).catch(error => {
                    if (error && error.message) {
                        chmDialog.error(error);
                    }
                }).finally(() => {
                    ScoreTrekBattle.View.loading('Tournament.Details.linkPlayer', false);
                });

                dialog.close();
            }
        });
    }

    function unlinkPlayer(participantId) {
        if (!STATUS.tournament) {
            return;
        }

        chmDialog.confirm('Unlink player ID from participant?', {
            title: 'Unlink Player ID'
        }).then(() => {
            ScoreTrekBattle.View.loading('Tournament.Details.unlinkPlayer', true);
            Api.request('/battle/participant/unlinkPlayer', {
                tournamentId: STATUS.tournament.id,
                participantId: participantId
            }).then(result => {
                if (result && result.done) {
                    updateTournament(true);
                }
            }).catch(error => {
                if (error && error.message) {
                    chmDialog.error(error);
                }
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Details.unlinkPlayer', false);
            });
        }).catch(ignore => {});
    }

    function setParticipantStatus(status, $participant, silent) {
        var participantId;

        participantId = $participant.attr('data-participant-id');

        ScoreTrekBattle.View.loading('Tournament.Details.setParticipantStatus', true);
        Api.request(`/battle/participant/status`, {
            status: status,
            tournamentId: STATUS.tournament.id,
            participantId: participantId
        }).then(result => {
            updateTournament().then(() => {
                if (!silent) {
                    setTimeout(() => {
                        var $movedParticipant;
                        $movedParticipant = STATUS.$view.find(`[data-id="lists"] [data-participant-id="${participantId}"]`);
                        // AnimationHandler.scrollIntoView($movedParticipant).then(() => {
                            AnimationHandler.pulse($movedParticipant, {'transform-origin': 'left center'});
                        // }).catch(ignore => {});
                    }, 400);
                }
            });
        }).catch(error => {
            if (error && error.message) {
                chmDialog.error(error);
            }
        }).finally(() => { 
            ScoreTrekBattle.View.loading('Tournament.Details.setParticipantStatus', false);
        });
    }

    function setParticipantPaid(paid, $participant) {
        ScoreTrekBattle.View.loading('Tournament.Details.setParticipantPaid', true);
        Api.request(`/battle/participant/paid`, {
            paid: paid,
            tournamentId: STATUS.tournament.id,
            participantId: $participant.attr('data-participant-id')
        }).then(result => {
            if (result && result.hasOwnProperty('paid')) {
                $participant.attr('data-paid', result.paid ? 'yes' : 'no');
                AnimationHandler.zoom($participant.find('[data-id="payStatus"]'), {'transform-origin': 'left center'});
            }
        }).catch(error => {
            if (error && error.message) {
                chmDialog.error(error);
            }
        }).finally(() => {
            ScoreTrekBattle.View.loading('Tournament.Details.setParticipantPaid', false);
        });
    }

    function setTournamentStatus(status, tournamentId) {
        if (!tournamentId) {
            tournamentId = STATUS.tournament.id;
        }

        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.Tournament.Edit.setStatus(tournamentId, status).then(updatedTournament => {
                if (updatedTournament) {
                    if (STATUS.$view && updatedTournament.status && STATUS.tournament && (STATUS.tournament.id === tournamentId)) {
                        STATUS.$view.attr('data-tournament-status', updatedTournament.status);
                    }
                    resolve(updatedTournament);
                } else {
                    reject(__i18n('error/STATUS_TRANSITION_FAILED'));
                }
            }).catch(reject).finally(() => {
                updateTournament().catch(ignore => {});
            });
        });
    }

    function showTournamentRegistrationLock() {
        showTournamentLockDialog(__i18n('tournament/registration/unlock/info'), STATUS.tournament.dateTimeRegistration, STATUS.tournament.timeZone);
    }

    function showTournamentWithdrawLock() {
        showTournamentLockDialog(__i18n('tournament/registration/withdraw/info'), STATUS.tournament.dateTimeWithdrawLimit, STATUS.tournament.timeZone);
    }

    function showTournamentLockDialog(info, dateTime, timeZone) {
        ScoreTrekBattle.Template.render('tournament/details/timeZone', {timezone: timeZone, class: 'ml-small mt-none'}).then(timeZoneView => {
            chmDialog.info(
                $('<div>').append(
                    `<div>${info}</div>`,
                    $(`<div class="row-center text-no-wrap mt-medium">`).append(
                        `<span class="text-yellow mr-small"><i class="fa-solid fa-calendar-week"></i></span>`,
                        `<span class="color-blue">${dateTime}</span>`,
                        timeZoneView.$view
                    )
                )
            );
        });
    }

    function prepareTeams(allowLeaveOuts) {
        return new Promise(function(resolve, reject) {
            if (!STATUS.tournament) {
                reject();
                return;
            }
            if (STATUS.tournament.preset && STATUS.tournament.preset.preset) {
                // TODO check if team assignments works
                if (STATUS.tournament.preset.playerType !== 'single') {
                    ScoreTrekBattle.Tournament.Team.assignMultiplePlayers(allowLeaveOuts, STATUS.tournament.participants, STATUS.tournament.preset, STATUS.tournament.teams).then(teams => {
                        resolve(teams);
                    }).catch(reject);
                } else {
                    ScoreTrekBattle.Tournament.Team.assignSinglePlayers(allowLeaveOuts, STATUS.tournament.participants).then(teams => {
                        resolve(teams);
                    }).catch(reject);
                }            
            } else {
                reject(__i18n('error/INVALID_INPUT'));
            }
        });
    }

    function assignTeams(teams) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Details.assignTeams', true);
            Api.request('/battle/tournament/assignTeams', {
                tournamentId: STATUS.tournament.id,
                teams: teams
            }).then(result => {
                if (result && result.done) {
                    resolve();
                } else {
                    reject();
                }
            }).catch(error => {
                reject(error);
            }).finally(()=> {
                ScoreTrekBattle.View.loading('Tournament.Details.assignTeams', false);
                updateTournament(true);
            });
        });
    }

    function prepareGroups(teams) {
        return new Promise(function(resolve, reject) {
            if (!STATUS.tournament) {
                reject();
                return;
            }
            if (STATUS.tournament.preset && STATUS.tournament.preset.preset) {
                ScoreTrekBattle.Tournament.Group.assignTeams(STATUS.tournament.participants, STATUS.tournament.preset, teams).then(groups => {
                    resolve(groups);
                }).catch(reject);
            } else {
                reject(__i18n('error/INVALID_INPUT'));
            }
        });
    }

    function checkPendingParticipants() {
        return new Promise(function(resolve, reject) {
            var isEmpty, isFull, hasPending, hasWaiting;

            if (!STATUS.tournament) {
                reject();
                return;
            }

            isEmpty = (STATUS.tournament.participantsCount === 0);
            isFull = (STATUS.tournament.participantsCount >= STATUS.tournament.participantsLimit);
            hasPending = (STATUS.tournament.requests && (STATUS.tournament.requests.length > 0));
            hasWaiting = (STATUS.tournament.waitlist && (STATUS.tournament.waitlist.length > 0));

            if (isEmpty) {
                chmDialog.error('error/NO_PLAYERS');
                reject();
                return;
            }

            if (!isFull && (hasPending || hasWaiting)) {
                chmDialog.confirm(__i18n('dialog/confirm/ignoreWaitlist/text', {tournamentName: STATUS.tournament.title}, true), {
                    title: __i18n('dialog/confirm/ignoreWaitlist/title'),
                    icon: '<i class="color-yellow"><i class="fa-solid fa-question"></i></i>',
                    buttonYes: __i18n('button/ignoreWaitlist'),
                    buttonNo: __i18n('button/cancel')
                }).then(() => {
                    checkVerifiedParticipants().then(resolve).catch(reject);
                }).catch(() => {
                    reject();
                });
            } else {
                checkVerifiedParticipants().then(resolve).catch(reject);
            }
        });
    }

    function checkVerifiedParticipants() {
        return new Promise(function(resolve, reject) {
            var hasNotVerified;

            if (!STATUS.tournament) {
                reject();
                return;
            }

            hasNotVerified = (STATUS.$view.find('[data-id="participantsItems"] > [data-verified="no"]').length > 0);

            if (hasNotVerified) {
                chmDialog.confirm(__i18n('dialog/confirm/playersNotVerified/text', {tournamentName: STATUS.tournament.title}, true), {
                    title: __i18n('dialog/confirm/playersNotVerified/title'),
                    icon: '<i class="color-light-pink"><i class="fa-solid fa-check-double"></i></i>',
                    buttonYes: __i18n('button/continue'),
                    buttonNo: __i18n('button/cancel')
                }).then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                });
            } else {
                resolve();
            }

        });
    }

    function checkUnpaidParticipants() {
        return new Promise(function(resolve, reject) {
            var $unpaidParticipants;;

            if (!STATUS.tournament) {
                reject();
                return;
            }

            $unpaidParticipants = STATUS.tournament.entryFee ? STATUS.$view.find('[data-id="participantsItems"] > [data-paid="no"]') : [];

            if ($unpaidParticipants.length > 0) {
                chmDialog.confirm(__i18n('dialog/confirm/playersUnpaid/text', {}, true), {
                    title: __i18n('dialog/confirm/playersUnpaid/title'),
                    icon: '<i class="color-red"><i class="fa-solid fa-euro-sign"></i></i>',
                    buttonYes: __i18n('button/continue'),
                    buttonNo: __i18n('button/cancel')
                }).then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                });
            } else {
                resolve();
            }

        });
    }

    function prepareStartTournament() {
        if (!STATUS.tournament) {
            return;
        }

        chmDialog.confirm(__i18n('dialog/confirm/startTournament/text', {tournamentName: STATUS.tournament.title}, true), {
            title: __i18n('dialog/confirm/startTournament/title'),
            icon: '<i class="color-blue"><i class="fa-solid fa-play"></i></i>',
            buttonYes: __i18n('button/startTournament'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            checkPendingParticipants().then(() => {
                checkUnpaidParticipants().then(() => {
                    configureTournament();
                }).catch(console.warn);
            }).catch(console.warn);
        }).catch(console.warn);
        
    }

    function configureTournament() {
        var configuration, isStarting;

        if (!STATUS.tournament) {
            return;
        }

        configuration = {};
        isStarting = false;

        setTournamentStatus('starting').then(() => {
            isStarting = true;
            return refreshTournament();
        }).then(() => {
            return new Promise((resolve, reject) => {
                prepareTeams().then(result => {
                    setTimeout(() => {
                        resolve(result);
                    }, 300);
                }).catch(reject);
            });
        }).then(teams => {
            configuration.teams = teams;
            return prepareGroups(teams);
        }).then(groups => {
            configuration.groups = groups;
            ScoreTrekBattle.View.loading('Tournament.Details.configureTournament.startTournament', true);
            startTournament(configuration).then(() => {
                if (STATUS.tournament) {
                    ScoreTrekBattle.View.goto(`/tournament/live/${STATUS.tournament.id}`);
                }
            }).catch(error => {
                console.error(error);
                refreshTournament().catch(ignore => {});
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Details.configureTournament.startTournament', false);
            });
        }).catch(error => {
            if (isStarting) {
                setTournamentStatus('scheduled').catch(ignore => {});
            }
            if (error) {
                chmDialog.error(error);
            }
        });
    }

    function startTournament(configuration) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Details.startTournament', true);
            Api.request('/battle/tournament/start', {
                tournamentId: STATUS.tournament.id,
                configuration: configuration
            }).then(result => {
                if (result && result.done) {
                    refreshTournament(true).then(resolve).catch(reject);
                } else {
                    chmDialog.error('error/TOURNAMENT_START_FAILED');
                    reject();
                }
            }).catch(error => {
                chmDialog.error((error && error.message) ? error : 'error/TOURNAMENT_START_FAILED');
                updateTournament();
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Details.startTournament', false);
            });
        });
    }

    function confirmCancelStartTournament() {
        return new Promise(function(resolve, reject) {
            chmDialog.confirm(__i18n('dialog/confirm/cancelStartTournament/text', {tournamentName: STATUS.tournament.title}, true), {
                title: __i18n('dialog/confirm/cancelStartTournament/title'),
                icon: '<i class="color-red"><i class="fa-solid fa-hand"></i></i>',
                buttonYes: __i18n('button/no'),
                buttonNo: __i18n('button/cancelStart')
            }).then(reject).catch(() => {
                cancelStartTournament().then(resolve).catch(reject);
            });
        });
    }

    function cancelStartTournament() {
        return new Promise(function(resolve, reject) {
            if (!STATUS.tournament) {
                reject();
                return;
            }

            setTournamentStatus('scheduled').then(() => {
                refreshTournament(true).then(resolve).catch(reject);
            }).catch(error => {
                if (error) {
                    chmDialog.error(error);
                }
                reject();
            });
        });
    }

    function checkReadMore() {
        var $wrapper, $description, hasReadMore;

        if (!STATUS.$view) {
            return;
        }

        $description = STATUS.$view.find('[data-id="description"]');
        $wrapper = STATUS.$view.find('[data-id="descriptionWrapper"]');

        $description.stop();

        $wrapper.addClass('hasReadMore').removeClass('hasReadLess');
        resetReadMore();

        hasReadMore = ($description.outerHeight() > ($wrapper.height() + 1));

        $wrapper.toggleClass('hasReadLess', hasReadMore);

        return hasReadMore;
    }

    function toggleReadMore(hasReadMore) {
        var $wrapper, $description, startHeight, endHeight;

        if (!STATUS.$view) {
            return;
        }

        $description = STATUS.$view.find('[data-id="description"]');
        $wrapper = STATUS.$view.find('[data-id="descriptionWrapper"]');

        if (hasReadMore === $wrapper.hasClass('hasReadMore')) {
            return;
        }

        if (hasReadMore) {
            startHeight = $description.height();
            $wrapper.addClass('hasReadMore');
            endHeight = $wrapper.height();
        } else {
            startHeight = $wrapper.height();
            endHeight = $description.css('height', '').height();
            $wrapper.removeClass('hasReadMore');
        }

        $wrapper.css('max-height', 'none');
        $description.css({
            'height': `${startHeight}px`,
            'overflow': 'hidden'
        }).stop().animate({
            height: `${endHeight}px`
        }, 400, function() {
            resetReadMore();
        });
    }

    function resetReadMore() {
        if (!STATUS.$view) {
            return;
        }

        STATUS.$view.find('[data-id="descriptionWrapper"]').stop().css('max-height', '');
        STATUS.$view.find('[data-id="description"]').stop().css({
            'height': '',
            'overflow': ''
        });
    }

    // action: fill | clear
    function tournamentAction(action, translationKey) {
        if (!STATUS.tournament) {
            return;
        }

        chmDialog.confirm(__i18n(`dialog/confirm/${translationKey}/text`), {
            title: __i18n(`dialog/confirm/${translationKey}/title`),
            buttonYes: __i18n(`dialog/confirm/${translationKey}/confirm`),
            buttonNo: __i18n(`button/no`)
        }).then(() => {
            ScoreTrekBattle.View.loading('Tournament.Details.tournamentAction', true);
            Api.request(`/battle/tournament/${action}`, {
                id: STATUS.tournament.id
            }).then(result => {
                if (result && result.tournament) {
                    ScoreTrekBattle.Event.trigger('tournament.updated', result.tournament);
                }
            }).catch(ignore => {}).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Details.tournamentAction', false);
                refreshTournament();
            });
        }).catch(() => {});
    }

    _this = {};

    $(window).on('resize', () => {
        toggleReadMore(checkReadMore());
    });

    ScoreTrekBattle.View.register('/tournament/details', onViewRender, onViewLoad, onViewUpdate, onViewUnload);

    ScoreTrekBattle.Event.on('action.tournament.assignTeams', function() {
        if (!STATUS.tournament || !STATUS.tournament.preset || (STATUS.tournament.preset.playerType === 'single')) {
            return;
        }

        prepareTeams(true).then(teams => {
            assignTeams(teams).catch(error => {
                console.warn(error);
                chmDialog.error((error && error.message) ? error : 'error/PERSIST_FAILED');
            });
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.tournament.start', function() {
        if (STATUS.tournament.status === 'starting') {
            confirmCancelStartTournament().then(() => {
                prepareStartTournament();
            }).catch(ignore => {});
            return;
        }

        prepareStartTournament();
    });

    ScoreTrekBattle.Event.on('action.tournament.cancelStart', function() {
        confirmCancelStartTournament().catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.tournament.register', function() {
        confirmRegisterPlayer(ScoreTrekBattle.Session.getPlayerId());
    });

    ScoreTrekBattle.Event.on('action.participant.confirmRequest', function() {
        confirmRegisterPlayer($(this).closest('[data-participant-id]').attr('data-player-id'));
    });

    ScoreTrekBattle.Event.on('action.tournament.withdraw', function() {
        if (ScoreTrekBattle.Session.hasPlayer()) {
            chmDialog.confirm(__i18n('dialog/confirm/withdraw/text', {tournamentName: STATUS.tournament.title, clubName: STATUS.tournament.club.name}, true), {
                title: __i18n('dialog/confirm/withdraw/title'),
                buttonYes: __i18n('button/withdraw'),
                buttonNo: __i18n('button/cancel')
            }).then(() => {
                withdrawPlayer();
            }).catch(() => {});
        } else {
            ScoreTrekBattle.Session.showLoginNotice();
        }
    });

    ScoreTrekBattle.Event.on('action.tournament.readMore', function() {
        toggleReadMore(false);
    });
    ScoreTrekBattle.Event.on('action.tournament.readLess', function() {
        toggleReadMore(true);
    });
    ScoreTrekBattle.Event.on('action.tournament.refresh', function(event) {
        refreshTournament();
    });
    ScoreTrekBattle.Event.on('action.tournament.fill', function(event) {
        tournamentAction('fill', 'fillTournament');
    });
    ScoreTrekBattle.Event.on('action.tournament.clear', function(event) {
        tournamentAction('clear', 'clearTournament');
    });
    ScoreTrekBattle.Event.on('action.tournament.export', function(event, listName) {
        ScoreTrekBattle.View.loading('Tournament.Details.export', true);

        Api.request('/battle/tournament/csv', {
            tournamentId: STATUS.tournament.id,
            listName: listName
        }).then(result => {
            if (!result.url) {
                chmDialog.error('error/FILE_GENERATION_FAILED');
                return;
            }

            FileManager.openWindow(
                result.url,
                __i18n('pdf/generated/title'),
                __i18n('pdf/generated/text'),
                __i18n('button/download'),
                '<i class="fa-solid fa-file-csv"></i>'
            );
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            ScoreTrekBattle.View.loading('Tournament.Details.export', false);
        });
    });
    ScoreTrekBattle.Event.on('action.participants.sort', function(event, sortKey) {
        setParticipantsSortKey(sortKey);
    });
    ScoreTrekBattle.Event.on('action.participant.add', function(event, autoFocus) {
        if (event.ctrlKey) {
            createParticipant();
            return;
        }
        addParticipantWithCode(autoFocus);
    });
    ScoreTrekBattle.Event.on('action.participant.add.manual', function() {
        addParticipantManual();
    });
    ScoreTrekBattle.Event.on('action.participant.accept', function() {
        setParticipantStatus('active', $(this).closest('[data-participant-id]'));
    });
    ScoreTrekBattle.Event.on('action.participant.wait', function() {
        setParticipantStatus('waiting', $(this).closest('[data-participant-id]'));
    });
    ScoreTrekBattle.Event.on('action.participant.reset', function() {
        setParticipantStatus('pending', $(this).closest('[data-participant-id]'));
    });
    ScoreTrekBattle.Event.on('action.participant.pay', function() {
        setParticipantPaid(true, $(this).closest('[data-participant-id]'));
    });
    ScoreTrekBattle.Event.on('action.participant.unpay', function() {
        setParticipantPaid(false, $(this).closest('[data-participant-id]'));
    });
    ScoreTrekBattle.Event.on('action.participant.deny', function() {
        var $item;
        $item = $(this).closest('[data-participant-id]');
        chmDialog.confirm(__i18n('dialog/confirm/removeRequest/text', {reference: $item.find('.player-name').text()}, true), {
            title: __i18n('dialog/confirm/removeRequest/title'),
            buttonYes: __i18n('button/remove'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            setParticipantStatus('removed', $item);
        }).catch(ignore => {});
    });
    ScoreTrekBattle.Event.on('action.participant.block', function() {
        setParticipantStatus('blocked', $(this).closest('[data-participant-id]'));
    });
    ScoreTrekBattle.Event.on('action.participant.info', function(event, action) {
        if (action === 'close') {
            chmDialog.close();
        }
        showParticipantInfo($(this).closest('[data-participant-id]').attr('data-participant-id'));
    });
    ScoreTrekBattle.Event.on('action.participant.contact', function(event, action) {
        if (action === 'close') {
            chmDialog.close();
        }
        showParticipantContact($(this).closest('[data-participant-id]').attr('data-participant-id'));
    });
    ScoreTrekBattle.Event.on('action.participant.verifyPlayer', function() {
        verifyPlayer($(this).closest('[data-participant-id]').attr('data-participant-id'));
    });
    ScoreTrekBattle.Event.on('action.participant.renamePlayer', function() {
        let $playerItem;
        $playerItem = $(this).closest('[data-participant-id]');
        renamePlayer($playerItem.attr('data-participant-id'), $playerItem.find('[data-id="playerName"]').text().trim());
    });
    ScoreTrekBattle.Event.on('action.participant.linkPlayer', function() {
        linkPlayer($(this).closest('[data-participant-id]').attr('data-participant-id'));
    });
    ScoreTrekBattle.Event.on('action.participant.unlinkPlayer', function() {
        unlinkPlayer($(this).closest('[data-participant-id]').attr('data-participant-id'));
    });
    ScoreTrekBattle.Event.on('action.participant.focus', function() {
        let $participant;

        if (!STATUS.$view) {
            return;
        }

        $participant = STATUS.$view.find(`[data-player-id="${ScoreTrekBattle.Session.getPlayerId()}"]`);

        AnimationHandler.scrollIntoView($participant).then(() => {
            AnimationHandler.pulse($participant);
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('preset.updated', function(preset) {
        if (!STATUS.active) {
            return;
        }

        onViewUpdate(STATUS.tournament.id);
    });

    return _this;
})();